<app-main [model]="model" [electionName]="electionName" [daysRemaining]="daysRemaining"></app-main>